/* How it works walkthrough: sequencing only (docs/specs/how-it-works-redesign-spec.md, 3 Oct 2026;
   scenes redrawn for the guided journey, 22 Oct 2026).
   The section's markup is written at each scene's end frame; this script plays the scenes by
   resetting a scene, then adding its beat classes (is-b1, is-b2 ...) on time. CSS does every
   movement; the script does timing, typing, the fake cursor and the credit countdown.
   One clock (requestAnimationFrame) drives it, so pause, jump and suspend are exact. */
(function () {
  'use strict';

  // Four scenes, 16.6 s, an equal share each (the guided journey, 22 Oct 2026). at/from/to are ms
  // into the scene. moves: the cursor arrives at `to` (a [data-c] name) at `at`, travelling for
  // `dur`; click shows one ripple. cls: beat n at `at`. Each scene holds for about a second after
  // its last movement and no longer (Beau, 3 Oct: longer holds read as a frozen animation). The
  // step's progress bar keeps filling meanwhile.
  var SCENES = [
    // Ask: the box is clicked, the ask is typed, Grade 5 lights up once "grade 5" is on screen,
    // Find it is pressed.
    { dur: 4150,
      cls: [[1300, 1], [3000, 2]],
      moves: [{ at: 400, dur: 350, to: 'field', click: true }, { at: 3000, dur: 350, to: 'go', click: true }],
      type: [[500, 2300]] },
    // Answer: the request chips arrive, the best-match card rises, Quiz ticks itself (the ask
    // named one), Get it free now is pressed.
    { dur: 4150,
      cls: [[300, 1], [800, 2], [1600, 3], [3000, 4]],
      moves: [{ at: 3000, dur: 450, to: 'get', click: true }] },
    // Make: the Make card rises, Worksheet is ticked and the button turns into "Make all 2", the
    // class note is typed, Make it is pressed and the balance counts down, the progress line runs
    // to the end of the scene.
    { dur: 4150,
      cls: [[300, 1], [900, 2], [3000, 3], [3450, 4]],
      moves: [{ at: 900, dur: 450, to: 'ws', click: true }, { at: 1500, dur: 350, to: 'note', click: true },
        { at: 3000, dur: 400, to: 'go', click: true }],
      type: [[1600, 2500]],
      count: [3000, 3450],
      prog: [3450, 4150] },
    // It lands in My files: both files settle in, PDF is pressed, the printed page slides up.
    { dur: 4150,
      cls: [[300, 1], [600, 2], [1500, 3], [1900, 4], [3000, 5]],
      moves: [{ at: 1500, dur: 600, to: 'pdf', click: true }] }
  ];
  var LOOPS = 2;
  var REST = [0.78, 0.94]; // where the cursor waits, as a fraction of the screen

  function creditWord(n) { return n + ' credit' + (n === 1 ? '' : 's'); }
  function clamp01(x) { return x < 0 ? 0 : (x > 1 ? 1 : x); }
  function easeOut(p) { return 1 - Math.pow(1 - p, 3); }

  function publish(name, data) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, data || {});
    } catch (e) { /* analytics is optional */ }
  }

  function Walkthrough(root) {
    var stage = root.querySelector('[data-hiw-stage]');
    var wrap = root.querySelector('.hiw-wt__stage-wrap');
    var screen = root.querySelector('[data-hiw-screen]');
    var toggle = root.querySelector('[data-hiw-toggle]');
    var steps = [].slice.call(root.querySelectorAll('[data-hiw-step]'));
    var panels = [].slice.call(root.querySelectorAll('[data-hiw-panel]'));
    var sceneEls = [].slice.call(root.querySelectorAll('.hiw-sc'));
    var cursor = root.querySelector('[data-hiw-cursor]');
    var ripple = root.querySelector('[data-hiw-ripple]');
    if (!stage || !screen || !sceneEls.length) return null;
    var n = Math.min(steps.length || SCENES.length, sceneEls.length, SCENES.length);
    var loopsMax = parseInt(root.getAttribute('data-loops'), 10) || LOOPS;
    var tapToggle = root.hasAttribute('data-hiw-tap');
    var startBal = parseInt(stage.getAttribute('data-start'), 10) || 0;
    var endBal = parseInt(stage.getAttribute('data-end'), 10) || 0;
    sceneEls.forEach(function (el) {
      [].forEach.call(el.querySelectorAll('[data-hiw-type]'), function (t) { t.setAttribute('data-full', t.textContent); });
    });

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var st = { scene: 0, t: 0, mode: 'idle', userPaused: false, loops: 0, visible: false, hover: false, kbd: false, reduced: !!(mq && mq.matches) };
    var raf = 0, last = 0, pos = {}, curXY = null, offs = [];

    function running() {
      if (st.reduced || st.userPaused || !st.visible || document.hidden) return false;
      if (st.mode === 'auto') return !st.hover && !st.kbd;
      return st.mode === 'single';
    }

    // ---- Scene state ----
    function typedEls(el) { return el.querySelectorAll('[data-hiw-type]'); }
    function setPill(el, v) { var p = el.querySelector('[data-hiw-pill] [data-hiw-pill-n]'); if (p) p.textContent = creditWord(v); }
    function setProg(el, p) { var b = el.querySelector('[data-hiw-prog]'); if (b) b.style.transform = 'scaleX(' + p + ')'; }
    function instant(el, fn) {
      el.classList.add('is-instant');
      fn();
      void el.offsetWidth; // commit the reset before transitions come back
      el.classList.remove('is-instant');
    }
    function resetScene(i) {
      var el = sceneEls[i];
      instant(el, function () {
        for (var b = 1; b <= 9; b++) el.classList.remove('is-b' + b);
        [].forEach.call(typedEls(el), function (t) { t.textContent = ''; t.parentNode.classList.remove('is-typing'); });
        setProg(el, 0);
        setPill(el, startBal);
      });
      pos = {}; curXY = null;
      cursor.classList.remove('is-on');
    }
    function endScene(i) {
      var el = sceneEls[i];
      instant(el, function () {
        (SCENES[i].cls || []).forEach(function (c) { el.classList.add('is-b' + c[1]); });
        [].forEach.call(typedEls(el), function (t) { t.textContent = t.getAttribute('data-full'); t.parentNode.classList.remove('is-typing'); });
        setProg(el, 1);
        if (SCENES[i].count) setPill(el, endBal);
      });
      cursor.classList.remove('is-on');
    }
    function showScene(i) {
      sceneEls.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      steps.forEach(function (li, k) {
        li.classList.toggle('is-active', k === i);
        var b = li.querySelector('[data-hiw-jump]');
        if (b) { if (k === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); }
      });
      panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
    }
    function setBars(p) {
      steps.forEach(function (li, k) {
        var bar = li.querySelector('[data-hiw-bar]');
        if (bar) bar.style.transform = 'scaleX(' + (k === st.scene ? p : 0) + ')';
      });
    }

    // ---- Cursor ----
    function point(name) {
      if (pos[name]) return pos[name];
      var el = sceneEls[st.scene].querySelector('[data-c="' + name + '"]');
      if (!el) return null;
      var r = el.getBoundingClientRect(), s = screen.getBoundingClientRect();
      pos[name] = [r.left - s.left + r.width / 2, r.top - s.top + r.height / 2];
      return pos[name];
    }
    function rest() { var s = screen.getBoundingClientRect(); return [s.width * REST[0], s.height * REST[1]]; }
    function placeCursor(t) {
      var moves = SCENES[st.scene].moves || [];
      var from = rest(), xy = from;
      for (var k = 0; k < moves.length; k++) {
        var m = moves[k], to = point(m.to);
        if (!to) continue;
        if (t >= m.at) { from = to; xy = to; continue; }
        if (t > m.at - m.dur) xy = [from[0] + (to[0] - from[0]) * easeOut((t - m.at + m.dur) / m.dur), from[1] + (to[1] - from[1]) * easeOut((t - m.at + m.dur) / m.dur)];
        else xy = from;
        break;
      }
      curXY = xy;
      cursor.style.transform = 'translate(' + xy[0].toFixed(1) + 'px,' + xy[1].toFixed(1) + 'px)';
      cursor.classList.add('is-on');
    }
    function click() {
      ripple.classList.remove('is-click');
      void ripple.offsetWidth;
      ripple.classList.add('is-click');
    }

    // ---- One frame of a scene at time t (prev: the time of the frame before) ----
    function apply(t, prev) {
      var sc = SCENES[st.scene], el = sceneEls[st.scene];
      (sc.cls || []).forEach(function (c) { if (c[0] > prev && c[0] <= t) el.classList.add('is-b' + c[1]); });
      (sc.moves || []).forEach(function (m) { if (m.click && m.at > prev && m.at <= t) click(); });
      var ts = typedEls(el);
      (sc.type || []).forEach(function (w, k) {
        var node = ts[k]; if (!node) return;
        var full = node.getAttribute('data-full') || '';
        var p = clamp01((t - w[0]) / (w[1] - w[0]));
        var txt = full.slice(0, Math.round(full.length * p));
        if (node.textContent !== txt) node.textContent = txt;
        node.parentNode.classList.toggle('is-typing', t >= w[0] && t < w[1] + 300);
      });
      if (sc.count) {
        var p2 = clamp01((t - sc.count[0]) / (sc.count[1] - sc.count[0]));
        setPill(el, Math.round(startBal + (endBal - startBal) * p2));
      }
      if (sc.prog) setProg(el, clamp01((t - sc.prog[0]) / (sc.prog[1] - sc.prog[0])).toFixed(3));
      placeCursor(t);
      setBars(clamp01(t / sc.dur));
    }

    function startScene(i, trigger) {
      st.scene = i; st.t = 0;
      resetScene(i);
      showScene(i);
      apply(0, -1);
      publish('hiw_step_view', { step: i + 1, trigger: trigger });
    }
    function holdScene(i) {
      st.scene = i; st.t = SCENES[i].dur;
      endScene(i);
      showScene(i);
      setBars(st.reduced ? 0 : 1);
    }

    function frame(now) {
      raf = 0;
      if (!running()) { render(); return; }
      var dt = last ? Math.min(now - last, 1000) : 16; // suspend and resume reset `last`, so a long gap is only ever a slow frame
      last = now;
      var prev = st.t;
      st.t = Math.min(st.t + dt, SCENES[st.scene].dur);
      apply(st.t, prev);
      if (st.t >= SCENES[st.scene].dur) {
        if (st.mode === 'single') {
          st.mode = 'held';
          holdScene(st.scene);
        } else {
          var next = st.scene + 1;
          if (next >= n) {
            st.loops += 1;
            next = 0;
            if (st.loops >= loopsMax) { st.mode = 'done'; holdScene(st.scene); render(); return; }
          }
          startScene(next, 'auto');
        }
      }
      render();
      kick();
    }
    function kick() {
      if (!running()) { last = 0; return; }
      if (!raf) raf = window.requestAnimationFrame(frame);
    }

    function render() {
      if (!toggle) return;
      toggle.hidden = st.reduced;
      var state = st.mode === 'done' ? 'replay' : ((st.userPaused || st.mode === 'held') ? 'play' : 'pause');
      if (toggle.getAttribute('data-state') !== state) {
        toggle.setAttribute('data-state', state);
        toggle.setAttribute('aria-label', state === 'replay' ? 'Replay walkthrough' : (state === 'play' ? 'Play walkthrough' : 'Pause walkthrough'));
      }
    }

    // ---- Controls ----
    function jump(i) {
      i = ((i % n) + n) % n;
      if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
      last = 0;
      st.userPaused = false;
      if (st.reduced) {
        st.mode = 'held';
        holdScene(i);
        publish('hiw_step_view', { step: i + 1, trigger: 'manual' });
      } else {
        st.mode = 'single';
        startScene(i, 'manual');
      }
      render();
      kick();
    }
    function onToggle() {
      if (st.mode === 'done') {
        st.loops = 0; st.mode = 'auto'; st.userPaused = false;
        startScene(0, 'auto');
        publish('hiw_replay', {});
      } else if (st.mode === 'held') {
        st.loops = 0; st.mode = 'auto'; st.userPaused = false;
        startScene((st.scene + 1) % n, 'auto');
      } else if (st.userPaused) {
        st.userPaused = false;
        st.hover = false; // pressing Play while the pointer is over the stage means play
      } else {
        st.userPaused = true;
        publish('hiw_pause', { step: st.scene + 1 });
      }
      render();
      kick();
    }

    function on(el, ev, fn, opt) { if (!el) return; el.addEventListener(ev, fn, opt); offs.push(function () { el.removeEventListener(ev, fn, opt); }); }

    steps.forEach(function (li, k) {
      on(li.querySelector('[data-hiw-jump]'), 'click', function () { jump(k); });
    });
    on(root.querySelector('[data-hiw-prev]'), 'click', function () { jump(st.scene - 1); });
    on(root.querySelector('[data-hiw-next]'), 'click', function () { jump(st.scene + 1); });
    on(toggle, 'click', onToggle);

    on(wrap, 'pointerenter', function (e) { if (e.pointerType === 'mouse' && !tapToggle) { st.hover = true; kick(); } });
    on(wrap, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { st.hover = false; kick(); } });
    var down = null, swipedAt = 0;
    on(wrap, 'pointerdown', function (e) { if (e.pointerType !== 'mouse') down = [e.clientX, e.clientY]; });
    on(wrap, 'pointerup', function (e) {
      if (!down) return;
      var dx = e.clientX - down[0], dy = e.clientY - down[1];
      down = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { swipedAt = Date.now(); jump(st.scene + (dx < 0 ? 1 : -1)); }
    });
    // Home page (compact): a tap or click on the stage pauses and plays it, like a video. The
    // Pause button stays the keyboard and screen-reader control.
    if (tapToggle) {
      on(wrap, 'click', function (e) {
        if (st.reduced || Date.now() - swipedAt < 500 || (e.target.closest && e.target.closest('[data-hiw-toggle]'))) return;
        onToggle();
      });
    }
    on(wrap, 'pointercancel', function () { down = null; });
    on(root, 'focusin', function (e) {
      var kb = false;
      try { kb = e.target !== toggle && e.target.matches(':focus-visible'); } catch (err) { kb = false; }
      st.kbd = kb;
      kick();
    });
    on(root, 'focusout', function (e) { if (!e.relatedTarget || !root.contains(e.relatedTarget)) { st.kbd = false; kick(); } });
    on(document, 'visibilitychange', function () { last = 0; kick(); });
    on(window, 'resize', function () { pos = {}; });
    if (mq) {
      var onMq = function () {
        st.reduced = mq.matches;
        if (st.reduced && st.mode !== 'idle') { st.mode = 'held'; holdScene(st.scene); }
        render();
        kick();
      };
      if (mq.addEventListener) on(mq, 'change', onMq);
    }

    // Arriving from a generator "?" link (#hiw-step-tick and so on): show that step, still, and
    // leave autoplay to the Play button.
    var hashed = steps.indexOf(location.hash ? document.getElementById(location.hash.slice(1)) : null);
    if (hashed > 0) { st.mode = 'held'; holdScene(hashed); }

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        st.visible = entries[entries.length - 1].intersectionRatio >= 0.5;
        if (st.visible && st.mode === 'idle' && !st.reduced) { st.mode = 'auto'; startScene(0, 'auto'); }
        kick();
      }, { threshold: [0, 0.5, 1] });
      io.observe(stage);
    } else {
      st.visible = true;
      if (!st.reduced) { st.mode = 'auto'; startScene(0, 'auto'); }
    }
    render();
    kick();

    return {
      root: root,
      jump: jump,
      destroy: function () {
        if (raf) window.cancelAnimationFrame(raf);
        if (io) io.disconnect();
        offs.forEach(function (f) { f(); });
        offs = [];
        root.__hiw = null;
      }
    };
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-hiw-wt]'), function (root) {
      if (!root.__hiw) root.__hiw = Walkthrough(root);
    });
  }

  // Theme editor: re-initialise a reloaded section, clean up an unloaded one, and jump the stage
  // to a step block selected in the sidebar.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-hiw-wt]'), function (root) { if (root.__hiw) root.__hiw.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var li = e.target && e.target.closest && e.target.closest('[data-hiw-step]');
    var root = li && li.closest('[data-hiw-wt]');
    if (root && root.__hiw) root.__hiw.jump(parseInt(li.getAttribute('data-hiw-step'), 10) - 1);
  });
  // Button clicks on any of the page's bands: header, the two cards, the closing band.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-hiw-cta]');
    if (a) publish('hiw_cta_click', { placement: a.getAttribute('data-hiw-cta') === 'walkthrough' ? 'walkthrough' : a.getAttribute('data-hiw-cta') });
  });

  window.HIWWalkthrough = { SCENES: SCENES, LOOPS: LOOPS, creditWord: creditWord };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
